/* eslint-disable import/prefer-default-export */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AccountMappingPayload } from "api/models";
import { updateAccountMapping } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useUpdateAccountMapping() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: AccountMappingPayload }) =>
      updateAccountMapping(id, payload).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries(userQueryKeys.accountMappings({}).slice(0, 1));
    },
  });
}
